import { TimelineBaseRequest } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetTimelineUserChangesRequest = Omit<TimelineBaseRequest, 'system'>;

export type TimelineUserChange = {
	changeCount: number;
	salesforceName: string;
	salesforceUsername: string;
};

export type TimelineUserChangesResponse = TimelineUserChange[];


export const getTimelineUserChanges = createGetEndpoint<GetTimelineUserChangesRequest, TimelineUserChangesResponse>(
	(request) => `/api/v3/timelines/user-changes?${getQueryString(request)}`
);
